import React from 'react';
import { Shield, Target, Book } from 'lucide-react';

const About = () => {
  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">About Praise I AM Apologetics</h1>
        
        <div className="about-content">
          <div className="about-section">
            <h2 className="display-medium section-title">Our Mission</h2>
            <p className="body-large">
              Praise I AM Apologetics exists to defend historic biblical Christianity through 
              rigorous apologetics, biblical theology, philosophy, and public debate. We are 
              committed to upholding the truth of Scripture and the purity of the gospel.
            </p>
          </div>

          <div className="core-values-grid">
            <div className="value-card">
              <Shield size={48} className="value-icon" />
              <h3 className="heading-2">Biblical Authority</h3>
              <p className="body-medium">
                Scripture alone is our final authority in all matters of faith and practice. 
                We approach theology and apologetics from a thoroughly biblical foundation.
              </p>
            </div>

            <div className="value-card">
              <Target size={48} className="value-icon" />
              <h3 className="heading-2">Free Grace Gospel</h3>
              <p className="body-medium">
                We explicitly reject works-based salvation systems and affirm that eternal life 
                is a free, irrevocable gift received by faith alone in Christ alone.
              </p>
            </div>

            <div className="value-card">
              <Book size={48} className="value-icon" />
              <h3 className="heading-2">Public Engagement</h3>
              <p className="body-medium">
                We engage skeptics, atheists, Muslims, Catholics, and other belief systems 
                in public debate, armed with Scripture, logic, and evidence.
              </p>
            </div>
          </div>

          <div className="about-section">
            <h2 className="display-medium section-title">What We Believe</h2>
            <div className="beliefs-list">
              <div className="belief-item">
                <h3 className="heading-3">Salvation by Grace Alone Through Faith Alone</h3>
                <p className="body-medium">
                  Eternal life is a free, irrevocable gift received by faith alone in Christ alone, 
                  apart from works or personal merit (Ephesians 2:8-9, Romans 4:5).
                </p>
              </div>

              <div className="belief-item">
                <h3 className="heading-3">Forensic Justification</h3>
                <p className="body-medium">
                  Justification is a legal declaration of righteousness, not a process of transformation. 
                  It is instant, complete, and irreversible at the moment of faith.
                </p>
              </div>

              <div className="belief-item">
                <h3 className="heading-3">Eternal Security</h3>
                <p className="body-medium">
                  Once saved, always saved. Those who believe in Christ possess eternal life that 
                  cannot be lost (John 10:28-29, Romans 8:38-39).
                </p>
              </div>

              <div className="belief-item">
                <h3 className="heading-3">Distinction Between Salvation and Discipleship</h3>
                <p className="body-medium">
                  Salvation is by faith alone. Discipleship involves obedience and faithful service. 
                  These are distinct biblical categories that must not be confused.
                </p>
              </div>

              <div className="belief-item">
                <h3 className="heading-3">Rewards vs Eternal Life</h3>
                <p className="body-medium">
                  Eternal life is a free gift. Inheritance, crowns, and rewards are earned by 
                  faithful discipleship and will vary among believers.
                </p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2 className="display-medium section-title">Our Approach</h2>
            <p className="body-large">
              We are uncompromising in our commitment to biblical truth and theological precision. 
              Our content is scripture-driven, argument-focused, and designed for those seeking 
              strong apologetic and theological clarity.
            </p>
            <p className="body-large">
              We are non-denominational and Bible-first, prioritizing the authority of Scripture 
              over tradition, experience, or human reasoning.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
